export {default} from './Reservations';



// WEBPACK FOOTER //
// ./src/pages/Reservations/index.ts